import styled from 'styled-components';
import MySafetySVG from '../../assets/onboarding/my-safety.svg';

const MySafety = styled(MySafetySVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '4.4rem'};
  height: ${props => props.height || '4.4rem'};
  fill: ${props => props.fill || props.theme.colors.black.base};
`;

export default MySafety;
